import { Box, Skeleton } from '@machobear/design-system'
import { useResponsiveValue } from '@machobear/design-system'

const EmptyProduct = () => {
  const isMobile = useResponsiveValue()({
    desktop: false,
    tablet: true,
    mobile: true
  })
  return (
    <Box
      borderRadius="large"
      padding="medium"
      gap="xsmall"
      background="neutralLight"
      display="flex"
      flexDirection="column"
      justifyContent="spaceBetween"
      maxWidth="xsmall"
      height="full"
    >
      <Box display="flex" flexDirection="column" gap="small">
        <Skeleton.Shape width={24} height={24} />

        <Box display="flex" flexDirection="column" gap="small">
          <Box style={{ width: 140 }}>
            <Skeleton.Header />
          </Box>

          <Box style={{ width: isMobile ? 260 : 360 }}>
            <Skeleton.Text lineCount={3} />
          </Box>
        </Box>
      </Box>
      <Box display="flex">
        <Box style={{ width: 100, height: 45 }}>
          <Skeleton.Shape />
        </Box>
      </Box>
    </Box>
  )
}

export default EmptyProduct
